module.exports = __webpack_public_path__ + "img/myself01.95c8e1eb.png";